
var SvgElement__prototype = SvgElement.prototype;